/* External dependencies */
import { gql } from '@apollo/client';

export const listOrdersQuery = gql`
  query listOrders($input: ListOrdersInput!) {
    listOrders(input: $input) {
      total
      orders {
        id
        name
        createdDate
        trackingNumber
        status
        parcelCount
        amount {
          amount
          currency
        }
        store {
          name
        }
        user {
          id
          email
          firstName
          lastName
        }
        statusUpdatedDate
        warehouse {
          id
        }
      }
    }
  }
`;

export const listPersonalOrdersQuery = gql`
  query listOrders($input: ListOrdersInput!) {
    listOrders(input: $input) {
      total
      orders {
        id
        name
        trackingNumber
        status
        amount {
          amount
        }
        store {
          name
        }
        warehouse {
          id
        }
      }
    }
  }
`;
